import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { ErrorMessage, FormikProps, useFormik } from "formik";
import { IMembershipVehicle, IMembershipVehicleList } from "./IMembershipVehicle";
import * as Yup from "yup";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { Upload } from "@mui/icons-material";
import { clearUpdateMembershipVehicleState, updateMembershipVehicle } from "../../Redux/Slicers/MembershipVehicle/UpdateMembershipVehicleSlicer";
import { addMembershipVehicle, clearAddMembershipVehicleState } from "../../Redux/Slicers/MembershipVehicle/AddMembershipVehicleSlicer";
import DatePickers from "../../Components/DatePicker/DatePicker";
import { getVehicleSearch } from "../../Redux/Slicers/Vehicle/VehicleSlicer";
import { debounce } from 'lodash'; // Make sure to install lodash if not already
import { Autocomplete, TextField } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { useParams } from 'react-router-dom';
import "./MembershipVehicle.scss";
interface MasterFormProps {
  vehicleForm: (data: FormikProps<any>) => void;
}

const VehicleForm: FunctionComponent<MasterFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const { updateableDate } = useAppSelector((state) => state.UpdateMembershipVehicle);
  const { searchResults } = useAppSelector((state) => state.Vehicle);
  const vehicleOptions = searchResults?.data.response.data || [];
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(dayjs()); //

  const { id } = useParams();

  const vehicleFrom = useFormik({
    initialValues: {
      ...initialValues,
    },
    validationSchema: Yup.object().shape({
      vehicle_id: Yup.string().required("Please choose vehicle"),
      // date: Yup.string().required('Please select a date'),
      // price_structure: Yup.string().required('Please select a Price Structure'),
    }),
    onSubmit: (value) => {
      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        const formattedValue = {
          vehicle_id: value.vehicle_id,
          user_designation_id: id,
          date: dayjs(value.date).toISOString(),
        };

        dispatch(
          updateMembershipVehicle({ ...formattedValue, id: updateableDate._id })
        );
      } else {
        console.log("valur", value);

        const formattedValue = {
          vehicle_id: value.vehicle_id,
          user_designation_id: id,
          // date: dayjs(value.date).toISOString(), // Convert date to ISO format
        };
        dispatch(addMembershipVehicle(formattedValue));
      }
    },
  });

  // useEffect(()=>{
  //   dispatch(getVehicleSearch())
  // },[])

  useEffect(() => {
    props.vehicleForm(vehicleFrom);
    if (updateableDate) {
      vehicleFrom.setFieldValue(
        "vehicle_plate_no",
        updateableDate.vehicle_plate_no
      );

      vehicleFrom.setFieldValue("vehicle_id", updateableDate.vehicle_id);
      if (updateableDate.date) {
        vehicleFrom.setFieldValue("date", updateableDate.date);
        setSelectedDate(dayjs(updateableDate.date));
      }
    }
    return () => {
      dispatch(clearAddMembershipVehicleState());
      dispatch(clearUpdateMembershipVehicleState());
      vehicleFrom.resetForm();
      setSelectedDate(null);
    };
  }, [updateableDate]);

  const debouncedSearch = useCallback(
    debounce((term: any) => {
      if (term.length > 0) {
        dispatch(getVehicleSearch(term));
      }
    }, 2000), // 2 seconds debounce
    [dispatch]
  );

  // Handle search input change
  const handleSearchChange = (event: any) => {
    const value = event.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handleVehicleSelect = (event: any, value: any) => {
    if (value) {
      vehicleFrom.setFieldValue("vehicle_plate_no", value.vehicle_plate_no);
      // You might want to set other fields based on the selected vehicle
      vehicleFrom.setFieldValue("vehicle_id", value._id);
    }
  };

  return (
    <form
      className="master_form"
      onSubmit={vehicleFrom.handleSubmit}
      onReset={vehicleFrom.handleReset}
      autoComplete="off">
      <Autocomplete
        id="vehicle_plate_no"
        options={vehicleOptions}
        getOptionLabel={(option) => option.vehicle_plate_no || ""}
        value={
          vehicleOptions.find(
            (v: any) =>
              v.vehicle_plate_no === vehicleFrom.values.vehicle_plate_no
          ) || null
        }
        onChange={handleVehicleSelect}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Vehicle Number"
            variant="outlined"
            onChange={handleSearchChange}
            value={searchTerm}
            error={
              vehicleFrom.touched.vehicle_plate_no &&
              Boolean(vehicleFrom.errors.vehicle_plate_no)
            }
            helperText={
              vehicleFrom.touched.vehicle_plate_no &&
              vehicleFrom.errors.vehicle_plate_no
            }
            InputProps={{
              ...params.InputProps,
              className: "uppercase",
            }}
          />
        )}
      />

      {/* <DatePickers
              label="Choose Date"
              format="YYYY-MM-DD"
              value={selectedDate || null}
              onChange={(val: any) => {
                if (val) {
                  setSelectedDate(val);
                  vehicleFrom.setFieldValue('date', val.format('YYYY-MM-DD')); // Update Formik field value
                } else {
                  setSelectedDate(null);
                  vehicleFrom.setFieldValue('date', ''); // Clear Formik field value if date is null
                }
              }}
            /> */}

      {/* <DatePickers
        label="Choose Date"
        format="DD-MM-YYYY"
        value={selectedDate || null}
        onChange={handleDateChange}

/> */}

      <button
        type="submit"
        style={{ display: "none" }}
      />
    </form>
  );
};
export default VehicleForm;

const initialValues: IMembershipVehicle = {
  id: "",
  _id: "",
  vehicle_plate_no: "", 
  is_accept: false,
  vehicle_id: "",
  user_designation_id: "",
  card_id: "",
  location_id: "",
  date: "",
};